import security from '../../../utils/security'
import http from '../../../utils/http'
import {
  AGREEMENT_INVOICE_TO_DEDUCTION_ERROR,
  AGREEMENT_INVOICE_TO_DEDUCTION_LOADING,
  AGREEMENT_INVOICE_TO_DEDUCTION_SUCCESS,
  AGREEMENT_INVOICE_TO_DEDUCTION_RESET
} from './mutation-types'

const state = {
  loading: false,
  error: '',
  items: []
}

function error (error) {
  return {type: AGREEMENT_INVOICE_TO_DEDUCTION_ERROR, error}
}

function loading (loading) {
  return {type: AGREEMENT_INVOICE_TO_DEDUCTION_LOADING, loading}
}

function success (items) {
  return {type: AGREEMENT_INVOICE_TO_DEDUCTION_SUCCESS, items}
}

function reset () {
  return {type: AGREEMENT_INVOICE_TO_DEDUCTION_RESET}
}

const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
}

const actions = {
  getItems ({commit}, agreement) {
    commit(loading(true))
    commit(error(null))
    const page = '/customers/' + http.extractId(agreement.customer) + '/' + agreement.id + '/invoice_to_deduction'

    return http.fetch(page)
      .then(response => {
        commit(loading(false))
        return response.json()
      })
      .then(data => {
        commit(success(data['hydra:member']))
      })
      .catch(e => {
        commit(loading(false))
        if (security.handleAuthorizationError(e)) {
          return
        }
        commit(error(e.message))
      })
  },
  reset({ commit }) {
    commit(reset());
  }
}

const mutations = {
  [AGREEMENT_INVOICE_TO_DEDUCTION_ERROR] (state, payload) {
    state.error = payload.error
  },
  [AGREEMENT_INVOICE_TO_DEDUCTION_LOADING] (state, payload) {
    state.loading = payload.loading
  },
  [AGREEMENT_INVOICE_TO_DEDUCTION_SUCCESS] (state, payload) {
    state.items = payload.items
  },
  [AGREEMENT_INVOICE_TO_DEDUCTION_RESET] (state) {
    state.items = [];
    state.loading= false,
    state.error = '';
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/agreement/invoice-to-deduction.js